export const GRID_TYPE = "flex";
export const GRID_JUSTIFY = "center";

export const GUTTER = { xs: 0, sm: 0, md: 12, lg: 18 };

export const COLUMN_FULL_WIDTH = 24;
export const COLUMN_HALF_WIDTH = 12;
export const COLUMN_THRID_WIDTH = 6;
